import * as actionTypes from "../actionTypes";

export const getFlightImages = payload => ({
    type: actionTypes.GET_FLIGHT_IMAGES,
    payload
})

export const setFlightImages = payload => ({
    type: actionTypes.SET_FLIGHT_IMAGES,
    payload
})

export const createFlightImages = payload => ({
    type: actionTypes.CREATE_FLIGHT_IMAGES,
    payload
})

export const updateFlightImages = payload => ({
    type: actionTypes.UPDATE_FLIGHT_IMAGES,
    payload
})